import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import SlumpTankGraph from "./_elements/SlumpTankGraph";
import OilTable from "./_elements/OilTable";
import AreaGraph1 from "./_elements/AreaGraph1";
import AreaGraph2 from "./_elements/AreaGraph2";
import AreaGraph3 from "./_elements/AreaGraph3";

type OwnProps = {
	vesselId: string;
};

type VDMDashboardLubeOilsProps = PropsFromRedux & OwnProps;
function VDMDashboardLubeOils(props: VDMDashboardLubeOilsProps) {
	return (
		<div className="mt-4">
			<div className="flex flex-col xl:flex-row gap-4">
				<div className="w-full xl:w-1/2">
					<SlumpTankGraph />
				</div>
				<div className="w-full xl:w-1/2">
					<OilTable />
				</div>
			</div>
			<section>
				<AreaGraph1 />
			</section>
			<section>
				<AreaGraph2 />
			</section>
			<section>
				<AreaGraph3 />
			</section>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardLubeOils);
